import mixpanel from "mixpanel-browser";

const MIXPANEL_PROJECT_TOKEN = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN;

mixpanel.init(MIXPANEL_PROJECT_TOKEN, {
  debug: process.env.NODE_ENV === "development" ? true : false,
  api_host: "https://api-eu.mixpanel.com",
  geolocate: false,
  ip: false,
});
console.log("Mixpanel inicializado");

export default mixpanel;
